import type { Label } from "@/api";
import { isHttpClientError } from "@/http";

export function formatEmptyLabelMessage({
  hasSearchQuery,
  searchQuery,
  hasFilterSelection,
}: {
  hasSearchQuery: boolean;
  searchQuery: string;
  hasFilterSelection: boolean;
}): string {
  if (hasSearchQuery && hasFilterSelection) {
    return `검색어 "${searchQuery}"와 선택한 라벨에 일치하는 라벨이 없습니다. 검색어나 필터를 바꿔 보세요.`;
  }
  if (hasSearchQuery) {
    return `검색어 "${searchQuery}"와 일치하는 라벨이 없습니다. 검색어를 바꿔 보세요.`;
  }
  if (hasFilterSelection) {
    return "선택한 라벨과 일치하는 라벨이 없습니다. 필터를 바꿔 보세요.";
  }
  return "아직 등록된 라벨이 없습니다. 새 라벨을 추가해 주세요.";
}

export function formatLabelText(label: Pick<Label, "key" | "value">): string {
  return label.key + " / " + label.value;
}

export function resolveErrorMessage(error: unknown): string {
  if (isHttpClientError(error)) {
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "라벨 요청을 완료하지 못했습니다. 잠시 후 다시 시도해 주세요.";
}
